export class GenererEtTransmettrePieceRequest {
    //Création
    constructor() {
        this.pieceIds = [];
    }

    //Identifiants des pièces de vente à générer et transmettre
    public pieceIds: string[];
}

export class GenererEtTransmettrePieceResultat {
    constructor() {
        this.dateDerniereTransmission = null;
        this.piecesTransmises = [];
        this.fichiersEfactureParPiece = {};
        this.piecesParametragePAIntrouvable = [];
        this.piecesSansLisible = [];
        this.piecesEnErreur = {};
    }

    //Date de la dernière transmission effectuée
    public dateDerniereTransmission: Date | null;

    // Liste des références des pièces de vente transmises avec succès
    public piecesTransmises: string[];

    //Fichiers XML générés par pièce
    public fichiersEfactureParPiece: Record<string, FileEFact>;

    //Liste des pièces pour lequel le paramétrage de PA est introuvable
    public piecesParametragePAIntrouvable: string[];
    
    //Liste des pièces sans lisible
    public piecesSansLisible: string[];

    //Liste des pièces en erreur
    public piecesEnErreur: Record<string, string>;
}

export class FileEFact {
    constructor() {
        this.nom = "";
        this.contenuBase64 = "";
    }

    public nom: string;

    public contenuBase64: string;
}